/*
   middleware
 */
import auth from "@/middleware/auth";

/*
    components
 */
import create from "@/views/modules/health-tracker/V2/sve/diagnostics-register/create.vue";
import createPCL from "@/views/modules/health-tracker/V2/sve/diagnostics-register/createPcl.vue";
import listQualification from "@/views/modules/health-tracker/V2/sve/diagnostics-register/listQualification.vue";
import createQualification from "@/views/modules/health-tracker/V2/sve/diagnostics-register/createQualification.vue";


const module = "/sve/diagnostics-register/";

const healthTrackerSVEDiagnosticsRegister = [
  {
    path: module.concat("employee/:employee_id/create/:is_edit"),
    name: "sveDiagnosticsRegisterCreate",
    component: create,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/sve/diagnostics/detalle-diagnostico/:employee_id/:diagnostic_id/:is_edit",
    name: "detailDiagnostic",
    component: create,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/sve/diagnostics/editar-diagnostico/:employee_id/:diagnostic_id/:is_edit",
    name: "editDiagnostic",
    component: create,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/sve/diagnostics/calificaciones/:employee_id/:diagnostic_id",
    name: "listQualification",
    component: listQualification,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/sve/diagnostics/nueva-calificacion/:employee_id/:diagnostic_id/:is_edit",
    name: "createQualification",
    component: createQualification,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/sve/diagnostics/calificacion/detalle-calificacion/:employee_id/:diagnostic_id/:qualitication_id/:is_edit",
    name: "detailQualification",
    component: createQualification,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/sve/diagnostics/calificacion/editar-calificacion/:employee_id/:diagnostic_id/:qualitication_id/:is_edit",
    name: "editQualification",
    component: createQualification,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/sve/diagnostics/pcl/nuevo-pcl/:employee_id/:is_edit",
    name: "addPCL",
    component: createPCL,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/sve/diagnostics/pcl/editar-pcl/:employee_id/:pcl_id/:is_edit",
    name: "editPCL",
    component: createPCL,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
  {
    path: "/sve/diagnostics/pcl/detalle-pcl/:employee_id/:pcl_id/:is_edit",
    name: "detailPCL",
    component: createPCL,
    meta: {
      middleware: [auth],
      roles: ["oh-specialist", "oh-analyst"],
    },
  },
];

export default healthTrackerSVEDiagnosticsRegister;
